var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-content__item-page ui-buttons ui-item-page" },
    [
      _c("h2", { staticClass: "ui-item-page__title" }, [_vm._v("UI Button")]),
      _c("h5", { staticClass: "ui-item-page__sub-title" }, [
        _vm._v("Basic usage"),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12 mb-30" },
            [
              _c("vue-button", [_vm._v("Default")]),
              _c("vue-button", { attrs: { type: "primary" } }, [
                _vm._v("Primary"),
              ]),
              _c("vue-button", { attrs: { type: "success" } }, [
                _vm._v("Success"),
              ]),
              _c("vue-button", { attrs: { type: "info" } }, [_vm._v("Info")]),
              _c("vue-button", { attrs: { type: "warning" } }, [
                _vm._v("Warning"),
              ]),
              _c("vue-button", { attrs: { type: "danger" } }, [
                _vm._v("Danger"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-12 mb-30" },
            [
              _c("vue-button", { attrs: { round: "" } }, [_vm._v("Round")]),
              _c("vue-button", { attrs: { type: "primary", round: "" } }, [
                _vm._v("Primary"),
              ]),
              _c("vue-button", { attrs: { type: "success", round: "" } }, [
                _vm._v("Success"),
              ]),
              _c("vue-button", { attrs: { type: "info", round: "" } }, [
                _vm._v("Info"),
              ]),
              _c("vue-button", { attrs: { type: "warning", round: "" } }, [
                _vm._v("Warning"),
              ]),
              _c("vue-button", { attrs: { type: "danger", round: "" } }, [
                _vm._v("Danger"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-12 mb-30" },
            [
              _c("vue-button", { attrs: { plain: "" } }, [_vm._v("Plain")]),
              _c("vue-button", { attrs: { type: "primary", plain: "" } }, [
                _vm._v("Primary"),
              ]),
              _c("vue-button", { attrs: { type: "success", plain: "" } }, [
                _vm._v("Success"),
              ]),
              _c("vue-button", { attrs: { type: "info", plain: "" } }, [
                _vm._v("Info"),
              ]),
              _c("vue-button", { attrs: { type: "warning", plain: "" } }, [
                _vm._v("Warning"),
              ]),
              _c("vue-button", { attrs: { type: "danger", plain: "" } }, [
                _vm._v("Danger"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-12 mb-30" },
            [
              _c("vue-button", { attrs: { icon: "fa fa-search", circle: "" } }),
              _c("vue-button", {
                attrs: { type: "primary", icon: "fa fa-search", circle: "" },
              }),
              _c("vue-button", {
                attrs: { type: "success", icon: "fa fa-search", circle: "" },
              }),
              _c("vue-button", {
                attrs: { type: "info", icon: "fa fa-search", circle: "" },
              }),
              _c("vue-button", {
                attrs: { type: "warning", icon: "fa fa-star", circle: "" },
              }),
              _c("vue-button", {
                attrs: { type: "danger", icon: "fa fa-trash", circle: "" },
              }),
            ],
            1
          ),
        ]),
        _c("h5", { staticClass: "ui-item-page__sub-title" }, [
          _vm._v("Disabled Button"),
        ]),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12 mb-30" },
            [
              _c("vue-button", { attrs: { disabled: "" } }, [
                _vm._v("Default"),
              ]),
              _c("vue-button", { attrs: { type: "primary", disabled: "" } }, [
                _vm._v("Primary"),
              ]),
              _c("vue-button", { attrs: { type: "success", disabled: "" } }, [
                _vm._v("Success"),
              ]),
              _c("vue-button", { attrs: { type: "info", disabled: "" } }, [
                _vm._v("Info"),
              ]),
              _c("vue-button", { attrs: { type: "warning", disabled: "" } }, [
                _vm._v("Warning"),
              ]),
              _c("vue-button", { attrs: { type: "danger", disabled: "" } }, [
                _vm._v("Danger"),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-3 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Text Button"),
              ]),
              _c("vue-button", { attrs: { type: "text" } }, [
                _vm._v("Text Button"),
              ]),
              _c("vue-button", { attrs: { type: "text", disabled: "" } }, [
                _vm._v("Text Button"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-2 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Loading Button"),
              ]),
              _c("vue-button", { attrs: { type: "primary", loading: true } }, [
                _vm._v("Loading"),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-3 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Icon Button"),
              ]),
              _c("vue-button", {
                attrs: { type: "primary", icon: "fa fa-search" },
              }),
              _c(
                "vue-button",
                { attrs: { type: "primary", icon_left: "fa fa-search" } },
                [_vm._v("Search")]
              ),
              _c(
                "vue-button",
                { attrs: { type: "primary", icon_right: "fa fa-search" } },
                [_vm._v("Search")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-3 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Button Group"),
              ]),
              _c(
                "vue-button-group",
                [
                  _c(
                    "vue-button",
                    {
                      attrs: { type: "primary", icon_left: "fa fa-angle-left" },
                    },
                    [_vm._v("Previous Page")]
                  ),
                  _c(
                    "vue-button",
                    {
                      attrs: {
                        type: "primary",
                        icon_right: "fa fa-angle-right",
                      },
                    },
                    [_vm._v("Next Page")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-3 mb-30" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Button Group"),
              ]),
              _c(
                "vue-button-group",
                [
                  _c("vue-button", {
                    attrs: { type: "primary", icon: "fa fa-edit" },
                  }),
                  _c("vue-button", {
                    attrs: { type: "primary", icon: "fa fa-share" },
                  }),
                  _c("vue-button", {
                    attrs: { type: "primary", icon: "fa fa-trash" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("h5", { staticClass: "ui-item-page__sub-title" }, [
        _vm._v("Sizes Button"),
      ]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-6 mb-30" },
            [
              _c(
                "vue-button",
                {
                  attrs: {
                    size: "big",
                    type: "warning",
                    icon_right: "fa fa-angle-right",
                  },
                },
                [_vm._v("Подробнее")]
              ),
              _c("vue-button", { attrs: { type: "warning" } }, [
                _vm._v("Default"),
              ]),
              _c("vue-button", { attrs: { size: "medium", type: "warning" } }, [
                _vm._v("Medium"),
              ]),
              _c("vue-button", { attrs: { size: "small", type: "warning" } }, [
                _vm._v("Small"),
              ]),
              _c("vue-button", { attrs: { size: "mini", type: "warning" } }, [
                _vm._v("Mini"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-6 mb-30" },
            [
              _c("vue-button", { attrs: { size: "big", round: "" } }, [
                _vm._v("Big"),
              ]),
              _c("vue-button", { attrs: { round: "" } }, [_vm._v("Default")]),
              _c("vue-button", { attrs: { size: "medium", round: "" } }, [
                _vm._v("Medium"),
              ]),
              _c("vue-button", { attrs: { size: "small", round: "" } }, [
                _vm._v("Small"),
              ]),
              _c("vue-button", { attrs: { size: "mini", round: "" } }, [
                _vm._v("Mini"),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }